import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../i18n';

export const Hero = () => {
  const { copy } = useLanguage();
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-white to-red-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-orange-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-red-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-yellow-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 animate-in fade-in slide-in-from-left duration-700">
            <div className="inline-block">
              <span className="px-4 py-2 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-sm font-medium">
                {copy.hero.badge}
              </span>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
              {copy.hero.title}
              <span className="bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">{copy.hero.accent}</span>
            </h1>
            
            <p className="text-xl text-muted-foreground leading-relaxed">
              {copy.hero.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white text-lg group"
              >
                {copy.hero.primary}
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => scrollToSection('about')}
                className="text-lg border-2"
              >
                {copy.hero.secondary}
              </Button>
            </div>

            <div className="pt-8">
              <div className="w-full h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent rounded-full"></div>
              <div className="mt-2 w-3/4 mx-auto h-0.5 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
            </div>
          </div>

          <div className="relative hidden lg:block animate-in fade-in slide-in-from-right duration-700">
            <div className="relative z-10">
              <img
                src={`${process.env.PUBLIC_URL}/images/hero-code.jpg`}
                alt="Code and Technology"
                className="rounded-2xl shadow-2xl"
              />
            </div>
            <div className="absolute -top-6 -right-6 w-72 h-72 bg-gradient-to-br from-orange-400 to-red-600 rounded-2xl -z-10 blur-2xl opacity-20"></div>
            <div className="absolute -bottom-6 -left-6 w-72 h-72 bg-gradient-to-br from-yellow-400 to-orange-600 rounded-2xl -z-10 blur-2xl opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
